import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const downloadQrBatchApiImpl = async (id: string): Promise<Either<ErrorEntity, void>> => {
    try {
        const hostUrl = di.get<HostApi>(HostApiName).url;
        const relativeUrl = `/qrcodes/download/${id}`;
        const token = di.get<HostApi>(HostApiName).getToken();

        // Fetch the blob with token
        const response = await fetch(`${hostUrl}${relativeUrl}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Get the blob from response
        const blob = await response.blob();
        
        // Create blob URL and download
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', `qr_batch_${id}.zip`);
        document.body.appendChild(link);
        link.click();
        
        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        return right(undefined);
    } catch (error) {
        console.error('Error downloading QR batch:', error);
        return left({
            code: "Error descargando lote de QRs",
        });
    }
};

export default downloadQrBatchApiImpl;